import { InvoiceTemplateListItem } from "@common/schemas/domains/invoice/invoice-template.schema";
import { Entity } from "@common/types/entity";
import { FilterMultiselectOption } from "@components/pageHeader/filters/FilterMultiselect/FilterMultiselect";

export const UNKNOWN_INVOICE_SOURCE_TEMPLATE_LABEL = "Unknown template";

export function resolveTemplateFilterEntityIds({
    selectedEntityIds,
    businessEntities,
}: {
    selectedEntityIds: number[] | undefined;
    businessEntities: Array<Pick<Entity, "id">>;
}): number[] {
    const businessEntityIds = businessEntities.map((entity) => entity.id);
    if (!selectedEntityIds || selectedEntityIds.length === 0) {
        return businessEntityIds;
    }
    return businessEntityIds.filter((id) => selectedEntityIds.includes(id));
}

export function buildInvoiceSourceTemplateOptions({
    templates,
    selectedIds,
    entitiesById,
}: {
    templates: InvoiceTemplateListItem[];
    selectedIds: string[];
    entitiesById: Map<number, Pick<Entity, "name">>;
}): FilterMultiselectOption[] {
    const isMultiEntity = new Set(templates.map((t) => t.entityId)).size > 1;

    const options = templates
        .toSorted((a, b) => a.name.localeCompare(b.name))
        .map((template): FilterMultiselectOption => {
            const archivedSuffix = template.archivedAt ? " (archived)" : "";
            return {
                value: template.id,
                label: `${template.name}${archivedSuffix}`,
                searchableLabel: template.name,
                ...(isMultiEntity && {
                    section:
                        entitiesById.get(template.entityId)?.name ??
                        "Unknown entity",
                }),
            };
        });

    const knownIds = new Set(templates.map((template) => template.id));
    for (const id of selectedIds) {
        if (!knownIds.has(id)) {
            options.push({
                value: id,
                label: UNKNOWN_INVOICE_SOURCE_TEMPLATE_LABEL,
                searchableLabel: UNKNOWN_INVOICE_SOURCE_TEMPLATE_LABEL,
            });
        }
    }

    return options;
}
